import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ShieldAlert, ChevronRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useStore } from '../context/StoreContext';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const NeverOutAlert = () => {
  const { getAuthHeader } = useAuth();
  const { selectedStore, getCurrentStore } = useStore();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/inventory-health`, { headers: getAuthHeader() })
      .then(res => setData(res.data))
      .catch(() => {});
  }, [getAuthHeader]);

  if (!data) return null;
  const perStore = data.summary_by_store?.[selectedStore];
  const statusOf = (x) => (perStore ? x.stores?.[selectedStore]?.status : x.status);
  const out = data.never_out.filter(x => statusOf(x) === 'out');
  const low = data.never_out.filter(x => statusOf(x) === 'low');
  if (!out.length && !low.length) return null;
  const lost = perStore ? perStore.lost_sales : data.summary.lost_sales;
  const names = [...out, ...low].slice(0, 4).map(x => x.name).join(', ');
  const more = out.length + low.length - 4;
  const storeName = perStore ? getCurrentStore().name : 'both stores';

  return (
    <Link to="/inventory-health" className="block" data-testid="never-out-alert">
      <div className={`rounded-xl border-2 p-4 flex items-center justify-between gap-4 ${out.length ? 'border-rose-300 bg-rose-50' : 'border-amber-300 bg-amber-50'}`}>
        <div className="flex items-start gap-3 min-w-0">
          <ShieldAlert className={`w-6 h-6 shrink-0 ${out.length ? 'text-rose-600' : 'text-amber-600'}`} />
          <div className="min-w-0">
            <p className={`font-bold ${out.length ? 'text-rose-900' : 'text-amber-900'}`}>
              Never-out watch ({storeName}): {out.length ? `${out.length} top seller${out.length === 1 ? '' : 's'} OUT of stock` : ''}{out.length && low.length ? ' · ' : ''}{low.length ? `${low.length} running low` : ''}
              {lost > 0 && <span className="font-normal"> · ≈${lost.toLocaleString(undefined, { maximumFractionDigits: 0 })} lost sales so far</span>}
            </p>
            <p className={`text-sm truncate ${out.length ? 'text-rose-800' : 'text-amber-800'}`}>{names}{more > 0 ? ` +${more} more` : ''}</p>
          </div>
        </div>
        <ChevronRight className="w-5 h-5 text-slate-400 shrink-0" />
      </div>
    </Link>
  );
};
